const map = {
	"./ar-YE/core": [
		8154,
		[
			125
		]
	],
	"./bg-BG/core": [
		2136,
		[
			136
		]
	],
	"./cs-CZ/core": [
		6945,
		[
			945
		]
	],
	"./da-DK/core": [
		3348,
		[
			348
		]
	],
	"./de-DE/core": [
		5217,
		[
			217
		]
	],
	"./en-GB/core": [
		4757,
		[
			757
		]
	],
	"./en-US/core": [
		562,
		[]
	],
	"./es-ES/core": [
		7710,
		[
			329
		]
	],
	"./fa-IR/core": [
		7620,
		[
			620
		]
	],
	"./fr-FR/core": [
		2119,
		[
			119
		]
	],
	"./hu-HU/core": [
		3983,
		[
			983
		]
	],
	"./id-ID/core": [
		3476,
		[
			476
		]
	],
	"./it-IT/core": [
		5876,
		[
			876
		]
	],
	"./ja-JP/core": [
		2389,
		[
			389
		]
	],
	"./ko-KR/core": [
		1525,
		[
			906
		]
	],
	"./nl-NL/core": [
		2456,
		[
			456
		]
	],
	"./pl-PL/core": [
		634,
		[
			634
		]
	],
	"./pt-BR/core": [
		6630,
		[
			630
		]
	],
	"./ro-RO/core": [
		1445,
		[
			445
		]
	],
	"./ru-RU/core": [
		3278,
		[
			278
		]
	],
	"./sk-SK/core": [
		3279,
		[
			279
		]
	],
	"./sr-Cyrl-CS/core": [
		9268,
		[
			268
		]
	],
	"./sr-Latn-CS/core": [
		183,
		[
			183
		]
	],
	"./sv-SE/core": [
		8173,
		[
			173
		]
	],
	"./tr-TR/core": [
		4958,
		[
			958
		]
	],
	"./uk-UA/core": [
		4154,
		[
			154
		]
	],
	"./uz-UZ/core": [
		555,
		[
			555
		]
	],
	"./zh-CN/core": [
		4291,
		[
			291
		]
	],
	"./zh-TW/core": [
		6526,
		[
			526
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5165;
module.exports = webpackAsyncContext;